module.exports = __webpack_public_path__ + "static/vis-ins-32a08ccf1c066e0f90c0661f0d215b8a.png";